import { useGetOrganisationReferrerEmailDomainWhitelistQuery } from '../generated/self-hosted-register';

const useOrganisationReferrerEmailDomainWhitelist = (orgCode?: string): [string[] | undefined, boolean] => {
  const [{ data, fetching }] = useGetOrganisationReferrerEmailDomainWhitelistQuery({
    variables: { orgCode: orgCode ?? '' },
    pause: !orgCode?.trim(),
    requestPolicy: 'cache-and-network',
  });

  return [data?.getOrganisationReferrerEmailDomainWhitelist, fetching];
};

export { useOrganisationReferrerEmailDomainWhitelist };
